/**
 * PillBarShell — skeleton stand-in for the Chat / Feed / Events / Recordings /
 * Rewards / Directory pill bar.
 *
 * The bar itself is CommunityPillBar, rendered by pages/Community.tsx,
 * pages/Events.tsx, pages/EventDetail.tsx and pages/Recordings.tsx, so all of
 * their route skeletons stand in for it.
 *
 * The pill widths used to be a hardcoded 5-entry list here, which is exactly
 * the drift this file's old comment warned about: adding a pill to the bar left
 * the shell one pill short. They now come from `COMMUNITY_PILLS` — the same
 * array the real bar maps over — so a pill added, removed or renamed there
 * updates the shell with it.
 *
 * Heights track the real bar: `.nav-pill` is `min-h-[36px]` with `px-4 py-2`
 * inside a `.nav-pill-container` (`p-[3px]`, `gap-[3px]`), wrapped in the page's
 * `py-3` bar — so the chrome doesn't shift when the real pill bar mounts. The
 * pills measure 37px, not the 36px floor: each holds an icon beside `text-[13px]`,
 * whose line box wins. Measured identical on both /community and /events.
 */

import { Skeleton } from '@/components/ui/skeleton';
import { visibleCommunityPills } from '@/components/shared/CommunityPillBar';

export function PillBarShell() {
  return (
    <div className="px-4 sm:px-6 py-3 flex items-center border-b border-border bg-card/80 backdrop-blur-sm z-40 flex-shrink-0">
      {/* Mirrors the real bar's scroller so six pills scroll rather than
          overflowing the page on a phone. */}
      <div className="flex-1 min-w-0 flex overflow-x-auto scrollbar-hide">
        <div className="mx-auto flex flex-shrink-0 items-center gap-[3px] rounded-[10px] bg-muted/50 p-[3px]">
          {visibleCommunityPills().map((pill) => (
            <Skeleton
              key={pill.id}
              className={`h-[37px] ${pill.skeletonWidth} flex-shrink-0 rounded-lg bg-primary/[0.07]`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
